module.exports = __webpack_public_path__ + "img/logo_bianco.cbf8375f.png";